import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import client from '../client';
import { parseEnvelope } from '../envelope';

const decimalMoney = z.string().regex(/^-?(0|[1-9][0-9]{0,14})\.[0-9]{4}$/);
const money = decimalMoney.nullable();
const explanationSchema = z.object({
  tax_line: z.string(),
  rows: z.array(z.object({ row_ref: z.string(), date: z.string(), payee: z.string(), amount: decimalMoney, category: z.string() }).strict()),
  exclusions: z.array(z.object({ row_ref: z.string(), amount: decimalMoney, reason: z.string() }).strict()),
  changes: z.array(z.record(z.string(), z.unknown())), recorded: money, deductible: money,
}).strict();

export type ScheduleCExplanation = z.infer<typeof explanationSchema>;

export function useScheduleCExplanation(grantId: string | null | undefined, taxYear: number | null | undefined, taxLine: string | null | undefined) {
  return useQuery({
    queryKey: ['accountant-schedule-c-explanation', grantId, taxYear, taxLine],
    enabled: Boolean(grantId && taxYear != null && taxLine),
    queryFn: async () => parseEnvelope(explanationSchema, (await client.get(`/api/accountant/clients/${grantId}/years/${taxYear}/schedule-c/${taxLine}/explanation`)).data).data,
  });
}
